import { Typography } from "@mui/material";
import AcxDialog from "./Dialog/AcxDialog";
import ErrorIcon from "@mui/icons-material/Error";
import AcxButton from "./AcxButton";

interface Props {
    showConfirmUpdateFilter: boolean;
    setShowConfirmUpdateFilter: React.Dispatch<React.SetStateAction<boolean>>;
    handleConfirm: () => void;
}

const ConfirmUpdateFilterDialog = ({
    showConfirmUpdateFilter,
    setShowConfirmUpdateFilter,
    handleConfirm,
}: Props) => {
    return (
        <AcxDialog
            isOpen={showConfirmUpdateFilter}
            onClose={() => {
                setShowConfirmUpdateFilter(false);
            }}
            title={
                <>
                    <ErrorIcon color="primary" />
                    <Typography fontSize={"20px"} fontWeight={600}>
                        You've updated a filter with active subscriptions.
                    </Typography>
                </>
            }
            subTitle={`This will change all emails for subscribers moving forward.`}
            children={
                <AcxButton
                    onClick={() => {
                        handleConfirm();
                        setShowConfirmUpdateFilter(false);
                    }}
                >
                    OK
                </AcxButton>
            }
        />
    );
};

export default ConfirmUpdateFilterDialog;
